import React, { useContext, useEffect, useState } from 'react';

import * as S from './styles';
import Modal from 'components/Modal';
import SimpleInput from 'components/SimpleInput';
import InputImgBigger from 'components/InputImgBigger';
import { ImgSavedProps } from 'types/ImgSavedProps';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { addBannerReq, editBannerReq } from './reqs';
import { BannerPlpProps, Collection } from 'types/BannerPlpProps';
import { optionsRedirectType } from 'utils/optionsInputs';
import SelectInput from 'components/SelectInput';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import AddCollections from 'components/AddCollections';
import { getPlpBanners } from 'pages/PlpBanners/reqs';

interface FormBannerPLPProps {
	isOpenForm: boolean;
	setIsOpenForm: React.Dispatch<React.SetStateAction<boolean>>;
	bannerToEdit: BannerPlpProps | null;
	setBannerToEdit: React.Dispatch<React.SetStateAction<BannerPlpProps | null>>;
	setListBanners: React.Dispatch<React.SetStateAction<BannerPlpProps[]>>;
	listBanners: BannerPlpProps[];
}

const initialStateForm: BannerPlpProps = {
	id: '',
	title: '',
	redirectId: optionsRedirectType[0].id.toString(),
	redirectOption: optionsRedirectType[0].option,
	urlImg: '',
	query: '',
	redirectValue: '',
	collections: []
};

export default function FormBannerPLP({
	isOpenForm,
	setIsOpenForm,
	bannerToEdit,
	listBanners,
	setBannerToEdit,
	setListBanners
}: FormBannerPLPProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [dataForm, setDataForm] = React.useState<BannerPlpProps>(
		bannerToEdit
			? bannerToEdit
			: {
					...initialStateForm
				}
	);
	const [isOpenCollectionsModal, setIsOpenCollectionsModal] = useState(false);

	function resetStatesComp() {
		setIsOpenForm(false);
		setDataForm(initialStateForm);
		setBannerToEdit(null);
	}

	function verifyIfCanSave() {
		if (dataForm.title === '') {
			handleNotify('Preenha o nome', 'error');
			return false;
		}

		if (dataForm.urlImg === '') {
			handleNotify('Insira a logo', 'error');
			return false;
		}

		return true;
	}

	async function saveBanner() {
		const canSave = verifyIfCanSave();

		if (!canSave) {
			handleNotify('Algum erro aconteceu', 'error');
			return;
		}

		const { isSuccess, bannerSaved } = await addBannerReq(
			dataForm,
			setIsOpenLoad,
			setMessage,
			handleNotify
		);

		if (isSuccess && bannerSaved) {
			setIsOpenLoad(true);
			setMessage('Atualizando lista...');
			const banners = await getPlpBanners(handleNotify);

			setIsOpenLoad(false);
			setListBanners(banners);
			resetStatesComp();
		} else {
			handleNotify('Erro ao salvar banner, tente novamente', 'error');
		}
	}

	async function editBanner() {
		const canSave = verifyIfCanSave();

		if (!canSave && listBanners.length === 0) {
			handleNotify('Algum erro aconteceu', 'error');
			return;
		}

		if (bannerToEdit) {
			const { isSuccess } = await editBannerReq(
				bannerToEdit,
				dataForm,
				setIsOpenLoad,
				setMessage,
				handleNotify
			);

			if (isSuccess) {
				setIsOpenLoad(true);
				setMessage('Atualizando lista...');
				const banners = await getPlpBanners(handleNotify);

				setIsOpenLoad(false);
				setListBanners(banners);
				resetStatesComp();
			}
		}
	}

	function findeOptionOnListByNumber(
		value: string,
		list: SelectInputItemProps[]
	) {
		return list.find((item) => item.id === value) || '';
	}

	useEffect(() => {
		return () => {
			resetStatesComp();
		};
	}, []);

	return (
		<Modal
			isOpenProps={isOpenForm}
			setIsOpenModal={() => {
				setIsOpenForm((value) => !value);
				resetStatesComp();
			}}
			title={'Formulário banner'}
			buttonClose={false}
		>
			<S.container>
				<S.contentForm>
					<SimpleInput
						label="Nome"
						initialValue={dataForm.title}
						getValue={(value: string) => {
							setDataForm((obj) => ({ ...obj, title: value }));
						}}
					/>

					<S.selectInputs $twoColunms={dataForm.redirectId !== 'collections'}>
						<SelectInput
							list={optionsRedirectType}
							getValue={(value: SelectInputItemProps | '') =>
								setDataForm((obj) => ({
									...obj,
									redirectOption:
										value === '' ? value : (value?.option as string),
									redirectId: value === '' ? value : (value?.id as string)
								}))
							}
							initialValue={
								dataForm.redirectValue === ''
									? ''
									: findeOptionOnListByNumber(
											dataForm.redirectId,
											optionsRedirectType
										)
							}
							label="Tipo de redirecionamento"
						/>

						{dataForm.redirectId !== 'collections' && (
							<SimpleInput
								label="Valor do redirecionamento"
								initialValue={dataForm.redirectValue}
								getValue={(value: string) => {
									setDataForm((obj) => ({ ...obj, redirectValue: value }));
								}}
							/>
						)}
					</S.selectInputs>

					{dataForm.redirectId === 'collections' && (
						<>
							<S.addCollections>
								<button
									onClick={() => {
										setIsOpenCollectionsModal(true);
									}}
								>
									Adicionar coleçoes
								</button>
							</S.addCollections>

							{isOpenCollectionsModal && (
								<AddCollections
									setCollections={(list: Collection[]) => {
										setDataForm((prev) => ({ ...prev, collections: list }));
									}}
									collections={dataForm?.collections || []}
									isOpen={isOpenCollectionsModal}
									setIsOpen={setIsOpenCollectionsModal}
								/>
							)}
						</>
					)}

					{dataForm.redirectId === 'collections' &&
						dataForm.collections.length > 0 && (
							<S.collectionsP>{`${dataForm.collections.length} ${dataForm.collections.length === 1 ? 'coleção cadastradas' : 'coleções cadastradas'} `}</S.collectionsP>
						)}

					<SimpleInput
						label="Query"
						initialValue={dataForm.query}
						getValue={(value: string) => {
							setDataForm((obj) => ({ ...obj, query: value }));
						}}
					/>

					<InputImgBigger
						idImagem="bannerImg"
						initialImage={dataForm.urlImg}
						getImage={(value: ImgSavedProps) => {
							setDataForm((obj) => ({
								...obj,
								urlImg: value?.url || ''
							}));
						}}
						label="Banner"
					/>
				</S.contentForm>

				<S.containerBtns>
					<S.cancel
						data-testid="cancelBtn"
						onClick={() => {
							resetStatesComp();
						}}
					>
						Cancelar
					</S.cancel>
					<S.save
						data-testid="saveBtn"
						onClick={async () => {
							if (bannerToEdit) {
								await editBanner();
							} else {
								await saveBanner();
							}
						}}
					>
						Salvar
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
